let components = {};

function initializeLazyBundleLoader(config) {
    return new Promise((resolve) => {
        ({ components } = config);
        resolve();
    });
}

function registerPaths(componentId) {
    if (components[componentId]) {
        const temp = {};
        temp[componentId] = components[componentId];
        window.morningstar.asterix.config.registerModulePaths(temp);
    }
}

export {
    initializeLazyBundleLoader,
    registerPaths,
};



// WEBPACK FOOTER //
// ./src/lazy-loader.js